@if (isLoading) {
	<mat-progress-spinner mode="indeterminate" class="mx-a" diameter="30"></mat-progress-spinner>
} @else {
	<form [formGroup]="formGroup" class="w-100">
		<app-card inCardTitle="Observation Type Group Detail"
				  icon="arrow_back"
				  [iconDisabled]="isSaving"
				  (iconClicked)="navigateBack()">
			<div *appCardContent>
				<app-row-with-toggle primaryText="Remove from map automatically"
									 secondaryText="Observations will disappear from map after set duration"
									 formControlName="autoRemove">
				</app-row-with-toggle>
				@if (formGroup.controls.autoRemove.value) {
					<div class="indent">
						<div class="field-row">
							<div class="field-row-title">
								Duration
							</div>
							<div class="field-row-element">
								<mat-form-field subscriptSizing="dynamic">
									<mat-select formControlName="durationInSeconds"
												required
												[errorStateMatcher]="InstantErrorStateMatcherInstance">
										@for (duration of durationValues; track duration.duration) {
											<mat-option [value]="duration.duration">{{duration.label}}</mat-option>
										}
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>
				} @else {
					<div class="pb-8"></div>
				}
			</div>
			<div *appCardContent class="field-row align-items-center pb-16">
				<div class="field-row-title">
					Map Icon Color
				</div>
				<div class="field-row-element flex-row align-items-center">
					@if (!mapColor.value) {
						<div class="text-muted">Default color will be used</div>
					} @else {
						<button mat-icon-button
								matTooltip="Reset value to default"
								(click)="mapColor.setValue(null)">
							<mat-icon>clear</mat-icon>
						</button>
					}
					<ngx-colors matSuffix
								ngx-colors-trigger
								colorsAnimation="popup"
								[formControl]="mapColor"
								class="suffix">
					</ngx-colors>
					@if (mapColor.hasError('notAColor')) {
						<mat-error class="ui-error">
							Valid color value is required
						</mat-error>
					}
				</div>
			</div>
			<div *appCardContent>
				<div class="py-8">
					<app-row-with-toggle primaryText="Audible Driver Alert"
										 secondaryText="Drivers will hear an audio alert when approaching an observation"
										 formControlName="isAudible">
					</app-row-with-toggle>
				</div>
			</div>
			<div *appCardContent>
				<div class="field-row mb-0">
					<div class="field-row-title">
						<h2>Observation Types</h2>
					</div>
					<div class="field-row-element">
						<button mat-stroked-button
								(click)="addObservationType()"
								[disabled]="formGroup.invalid || formGroup.pending">
							Add
						</button>
					</div>
				</div>

				@if (isLoadingObservationTypes) {
					<mat-progress-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-progress-spinner>
				} @else if (!observationTypes.length) {
					<div class="text-muted">
						No observation types are defined for the group yet.
					</div>
				} @else {
					<mat-nav-list>
						<mat-menu #menuGroup="matMenu">
							<ng-template matMenuContent let-type="type">
								<button mat-menu-item (click)="updateObservationType(type)">
									Update
								</button>
								@if (!isCartegraphEnabled) {
									<button mat-menu-item (click)="removeObservationType(type)">
										Remove
									</button>
								}
							</ng-template>
						</mat-menu>
						@for (ot of observationTypes; track ot.id) {
							<mat-list-item (click)="updateObservationType(ot)">
								<a matListItemTitle>{{ ot.title }}</a>
								<div matListItemMeta>
									<button mat-icon-button
											(click)="$event.stopPropagation()"
											[disabled]="formGroup.invalid || formGroup.pending"
											[matMenuTriggerFor]="menuGroup"
											[matMenuTriggerData]="{type:ot}"
											aria-label="Menu">
										<mat-icon>more_vert</mat-icon>
									</button>
								</div>
							</mat-list-item>
							@if (!$last) {
								<mat-divider></mat-divider>
							}
						}
					</mat-nav-list>
				}
			</div>
		</app-card>
	</form>

}
